import {Component, OnDestroy} from '@angular/core';
import {Subscription} from "rxjs/Subscription";
import {Router} from "@angular/router";
import {Ng2DeviceService} from "ng2-device-detector";
import {Docker} from "../../recursos/modelo/docker";
import {UtilConfig} from "../../../autenticacion/servicios/UtilConfig";
import {LayoutService} from "../../recursos/servicio/layout.service";
import {SpeechRecognitionService} from "../../recursos/servicio/speech-recognition.service";

@Component({
    moduleId: module.id,
    selector: 'footer-cmp',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})

export class FooterComponent implements OnDestroy {
    subscription: Subscription;
    docker: Docker;
    test: Date = new Date();
    grabando: boolean;
    opcionesGrabadoBuscar: boolean;
    opcionesGrabadoIrA: boolean;
    textobusqueda: string;
    deviceInfo;

    authorities = {
        ROLE_USUARIO_LISTAR: false,
        ROLE_CUSTOMER_LISTAR: false,
        ROLE_LOG_SUNAT_LISTAR: false,
        ROLE_REPORTE_LISTAR: false,
        ROLE_INDICADORES_GENERAL: false
    };

    constructor(private util: UtilConfig,
                private layoutService: LayoutService,
                private speechRecognitionService: SpeechRecognitionService,
                private router: Router,
                private deviceService: Ng2DeviceService) {
        this.deviceInfo = this.deviceService.getDeviceInfo();
        // subscribe to home component messages
        this.docker = util.getDocker();

        this.grabando = false;
        this.opcionesGrabadoBuscar = false;
        this.opcionesGrabadoIrA = false;
        this.textobusqueda = "";
        this.subscription = this.layoutService.getDocker().subscribe(docker => {
            this.docker = docker;
        });
        this.inactivateSpeechSearch();

        // VERIFICA LOS PERMISOS DEL USUARIO LOGEADO
        this.authorities = this.util.verificarAuthorities(this.authorities);

    }

    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.subscription.unsubscribe();
        this.speechRecognitionService.DestroySpeechObject();
    }


    inactivateSpeechSearch(): void {
        this.speechRecognitionService.DestroySpeechObject();
        this.grabando = false;
        this.textobusqueda = "";
    }

    activateSpeechSearch(): void {
        this.textobusqueda = "";
        this.opcionesGrabadoIrA = false;
        this.opcionesGrabadoBuscar = false;
        this.grabando = true;
        if (this.grabando) {
            this.speechRecognitionService.record(false)
                .subscribe(
                    //listener
                    (value) => {
                        if (this.textobusqueda == null)
                            this.textobusqueda = "";
                        this.textobusqueda += value;
                        this.interpretarVoice();
                    },
                    //errror
                    (err) => {
                        if (err.error == "no-speech") {
                            //this.activateSpeechSearch();
                        }
                    },
                    //completion
                    () => {
                        this.grabando = false;
                        //this.activateSpeechSearch();
                    });
        }
    }

    interpretarVoice() {
        this.opcionesGrabadoIrA = false;
        this.opcionesGrabadoBuscar = false;
        if (this.textobusqueda.toLocaleUpperCase() == "IR A") {
            this.textobusqueda += " ";
            this.opcionesGrabadoBuscar = false;
            this.opcionesGrabadoIrA = true;
            return;
        }

        if (this.textobusqueda.toLocaleUpperCase() == "BUSCAR") {
            this.textobusqueda += " ";
            this.opcionesGrabadoBuscar = true;
            this.opcionesGrabadoIrA = false;
            return;
        }
        if (this.textobusqueda.toLocaleUpperCase() == "IR A ACTAS") {
            this.router.navigate(['/content', {outlets: {'second': ['actas']}}]);
            this.grabando = false;
            this.inactivateSpeechSearch();
            return;
        }

        if ((this.textobusqueda.toLocaleUpperCase() == "CREAR NUEVA ACTA") || (this.textobusqueda.toLocaleUpperCase() == "CREAR ACTA NUEVA")) {
            this.router.navigate(['/content', {outlets: {'second': ['actas', 'create']}}]);
            this.grabando = false;
            this.inactivateSpeechSearch();
            return;
        }

        if (this.textobusqueda.toLocaleUpperCase() == "IR A USUARIOS") {
            this.router.navigate(['/content', {outlets: {'second': ['usuario']}}]);
            this.grabando = false;
            this.inactivateSpeechSearch();
            return;
        }

        if (this.textobusqueda.toLocaleUpperCase().indexOf("BUSCAR USUARIO") != -1) {
            let criterio = this.textobusqueda.substr(15);
            this.router.navigate(['/content', {
                outlets: {
                    'second': ['usuario', {
                        "busqueda": criterio,
                        "estado": "TODOS"
                    }]
                }
            }]);
            this.grabando = false;
            this.inactivateSpeechSearch();
            return;
        }


        if ((this.textobusqueda.toLocaleUpperCase().indexOf("VER CONTACTO DE") != -1) ||
            (this.textobusqueda.toLocaleUpperCase().indexOf("VER CORREO DE ") != -1) ||
            (this.textobusqueda.toLocaleUpperCase().indexOf("VER TELÉFONO DE ") != -1) ||
            (this.textobusqueda.toLocaleUpperCase().indexOf("VER MOVIL DE ") != -1)) {
            let criterio = this.textobusqueda.substr(15);
            this.router.navigate(['/content', {
                outlets: {
                    'second': ['contactos', {
                        "busqueda": criterio,
                        "estado": "TODOS"
                    }]
                }
            }]);
            this.grabando = false;
            this.inactivateSpeechSearch();
            return;
        }

    }


    closeSBDito() {
        this.grabando = false;
        this.inactivateSpeechSearch();
    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/shared/footer/footer.component.ts